import React, { PureComponent } from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import SwaggerUI from 'swagger-ui-react';
// import "swagger-ui-react/swagger-ui.css";

import { UiStore } from '../../core/ui-store';
import { UserStore } from '../../core/user-store';

import './catalog-swagger-ui.scss';
import './CatalogPage.scss';
import { track, TrackedEvent } from '../../core/analytics';
import { OktaScopes, OktaScopesConfig } from '../../core/okta-auth-api.consts';
import PageNotFound from '../not-found/PageNotFound';

interface StoresProps {
  userStore?: UserStore;
  uiStore?: UiStore;
}

type Props = StoresProps & RouteComponentProps;

interface State {}

const CatalogPage = inject(
  'userStore',
  'uiStore'
)(
  observer(
    withRouter(
      //@ts-ignore
      class CatalogPage extends PureComponent<Props, State> {
        documentClickHandler = (e: MouseEvent) => {
          const buttonEl: HTMLButtonElement = (e.target as HTMLElement).closest('button');
          if (buttonEl) {
            track(TrackedEvent.swaggerButtonClicked, { className: buttonEl.className });
            return;
          }
          const selectEl: HTMLSelectElement = (e.target as HTMLElement).closest('select');
          if (selectEl) {
            track(TrackedEvent.swaggerSelectClicked, { className: selectEl.className });
            return;
          }
          const anchorEl: HTMLAnchorElement = (e.target as HTMLElement).closest('a');
          if (anchorEl) {
            track(TrackedEvent.swaggerLinkClicked, { href: anchorEl.href });
            return;
          }
        };

        documentChangeHandler = (e: Event) => {
          const inputEl: HTMLInputElement = (e.target as HTMLElement).closest('input');
          if (inputEl) {
            track(TrackedEvent.swaggerInputChanged, { type: inputEl.type });
            return;
          }
          const selectEl: HTMLSelectElement = (e.target as HTMLElement).closest('select');
          if (selectEl) {
            track(TrackedEvent.swaggerSelectChanged, { className: selectEl.className });
            return;
          }
        };

        componentDidMount() {
          document.addEventListener('click', this.documentClickHandler);
          document.addEventListener('change', this.documentChangeHandler);
        }

        componentWillUnmount() {
          document.removeEventListener('click', this.documentClickHandler);
          document.removeEventListener('change', this.documentChangeHandler);
        }

        render() {
          const matchingScopeIndex: number = Object.keys(OktaScopesConfig)
            .map((val) => val.toLocaleLowerCase())
            .findIndex((val) => val === this.props.match.params['id']);

          if (matchingScopeIndex < 0) {
            return <PageNotFound />;
          }

          const matchingScope: OktaScopes = Object.keys(OktaScopesConfig)[matchingScopeIndex] as OktaScopes;
          const isGroupValid: boolean = !!this.props.userStore.userOktaGroupsMap[OktaScopesConfig[matchingScope].group];

          if (!isGroupValid) {
            return <PageNotFound />;
          }

          return (
              <SwaggerUI
                url={`/specs/${this.props.match.params['id']}${this.props.match.params['version'] ? "-" + this.props.match.params['version'] : ''}.yaml`}
                docExpansion="list"
                deepLinking={true}
                tryItOutEnabled={false}
                defaultModelExpandDepth={2}
              />
          );
        }
      }
    )
  )
);

export default CatalogPage;
